module.exports = __webpack_public_path__ + "static/tacoma2-d586b3552f6a0ad3ddadad10269713b6.webp";